import styled from "styled-components";

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 150px);
`;

export const EmptyMessagesSuppressionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
`;